import gsap from "gsap";
/**
 * Establish Cart Proxy handler for reactive object values
 */
export function setCartProxy() {
	window.Zero = window.Zero || {};
	window.Zero.Cart = window.Zero.Cart || {};

	const handler = {
		set: (target, property, value) => {
			target[property] = value;

			if (property === "count") displayQuantities(value);
			if (property === "discount")
				displayValue(
					"[data-display-discount]",
					window.Zero.Intl.format(
						(value * window.Zero.Currency.rate) / 100
					)
				);
			if (property === "subtotal")
				displayValue(
					"[data-display-subtotal]",
					window.Zero.Intl.format(
						(value * window.Zero.Currency.rate) / 100
					)
				);
			if (property === "total")
				displayValue(
					"[data-display-total]",
					window.Zero.Intl.format(
						(value * window.Zero.Currency.rate) / 100
					)
				);

			return true;
		},
	};

	window.Zero.Cart.stats = {
		count: 0,
		discount: 0,
		subtotal: 0,
		total: 0,
	};

	window.Zero.Cart.stats = new Proxy(window.Zero.Cart.stats, handler);

	/** Proxy established, let's update the object if there's a cart */
	checkCart();
}

/**
 * Check cart
 * @returns
 */
export async function checkCart() {
	fetch("/cart.json", {
		method: "get",
	})
		.then((response) => response.json())
		.then((response) => {
			let stats = {
				count: response.item_count,
				discount: response.total_discount,
				subtotal: response.items_subtotal_price,
				total: response.total_price,
			};

			let getPrice = 0;
			let getDiscount = 0;
			let getCount = 0;

			[...response.items].forEach((item) => {
				if (
					item.handle == "build-a-box" ||
					item.handle == "build-a-box-pre-built-bundle"
				) {
					let boxKey = item.properties._box_key;
					let boxDiscount = item.properties._discount
						? (100 - parseFloat(item.properties._discount)) / 100
						: 1;
					let priceTotal = 0;
					let discountTotal = 0;

					[...response.items].forEach((prod) => {
						if (prod.properties._box_key == boxKey) {
							let thisPrice = prod.line_price * boxDiscount;

							// 	prod,
							// 	prod.price,
							// 	prod.line_price,
							// 	boxDiscount
							// );

							priceTotal += thisPrice;
							discountTotal += prod.line_price - thisPrice;
						}
					});

					getPrice += priceTotal;
					getDiscount += discountTotal;
					getCount += item.quantity;
				} else {
					let type = item.product_type.toLowerCase();

					if (
						type.indexOf("pouch") === -1 &&
						type.indexOf("single") === -1
					) {
						getPrice += item.line_price;

						if (item.line_level_total_discount > 0) {
							getDiscount += item.line_level_total_discount;
						} else if (
							item.selling_plan_allocation?.compare_at_price
						) {
							getDiscount +=
								item.selling_plan_allocation.compare_at_price -
								item.line_price;
						}

						getCount += item.quantity;
					}
				}
			});

			/** Called individually in order to not interfere with the Proxy */
			window.Zero.Cart.items = response.items;
			if (window.Zero.Cart.stats.discount !== getDiscount)
				window.Zero.Cart.stats.discount = getDiscount;
			if (window.Zero.Cart.stats.subtotal !== getPrice)
				window.Zero.Cart.stats.subtotal = getPrice;
			if (window.Zero.Cart.stats.total !== stats.total)
				window.Zero.Cart.stats.total = stats.total;
			if (window.Zero.Cart.stats.count !== getCount) {
				window.Zero.Cart.stats.count = getCount;
				/** Send cart event that can be listened to **/
				document.dispatchEvent(
					new CustomEvent("cartChange", { detail: window.Zero.Cart })
				);
			}

			/** If cart is empty, show empty status **/
			if (window.Zero.Cart.stats.count == 0) {
				document.querySelector("cart-wrapper")?.displayEmpty();
			}
			/** If on cart page, update the cart items **/
			else if (document.querySelector("cart-wrapper")) {
				document.querySelector("cart-wrapper")?.updateCartItems();
			}

			/** Pass JSON back to call */
			return response;
		})
		.catch((e) => {
			console.error(e);
		});
}

// export async function updateCartItems() {
// 	fetch(`${window.Shopify.routes.root}cart?section_id=section--cart-items`, {
// 		method: "GET",
// 	})
// 		.then((response) => response.text())
// 		.then((responseText) => {
// 			const html = new DOMParser().parseFromString(
// 				responseText,
// 				"text/html"
// 			);

// 			document.querySelector("cart-wrapper").outerHTML =
// 				html.querySelector("cart-wrapper").outerHTML;

// 			customElements.define("cart-wrapper", Cart);
// 			customElements.define("cart-item", CartItems);
// 			customElements.define("cart-remove", CartRemove);
// 			customElements.define("cart-add", CartAdd);

// 			window.Zero.lazyLoad.update();
// 		});
// }

/**
 * Add to cart
 * @returns cart
 */
export async function addToCart(vid, quantity, properties = {}, callback = () => null) {
	let url = window.Shopify.routes.root + "cart/add.js";

	await fetch(url, {
		method: "POST",
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			items: [
				{
					id: vid,
					quantity: quantity,
					properties: properties,
				},
			],
		}),
		})
		.then((response) => {
			// document.dispatchEvent(
			// 	new CustomEvent("cartChange", { detail: window.Zero.Cart })
			// );
			checkCart();
			callback(response.json());
			return response.json();
		})
		.catch((error) => error);
}

/**
 * Add to cart
 * @returns cart
 */
export async function removeIdsFromCart(vids) {
	let url = window.Shopify.routes.root + "cart/update.js";
	const updates = vids.reduce(
		(accumulator, currentValue) => ({ ...accumulator, [currentValue]: 0 }),
		{}
	);

	await fetch(url, {
		method: "POST",
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			updates: updates,
		}),
	})
		.then((response) => {
			response.json();
			checkCart();
		})
		.catch((error) => error);
}

export const displayQuantities = (value) => {
	displayValue("[data-display-quantity]", value, true);
};

/** Let's pass values to the same sort of loop */
export const displayValue = (selector, value, hide = false) => {
	Array.prototype.slice
		.call(document.querySelectorAll(selector))
		.forEach((el) => {
			if (hide && value > 0) el.classList.remove("hidden");
			if (hide && value === 0) el.classList.add("hidden");

			// More prominent visual feedback on quantity badge in header:
			if (selector === "[data-display-quantity]") {
				gsap.fromTo(
					document.querySelectorAll(selector),
					{
						opacity: 0,
						translateY: `5px`,
					},
					{
						opacity: 1,
						duration: 0.3,
						translateY: 0,
						ease: "Power2.inOut",
					}
				);
			}

			if (el.dataset.sup && el.dataset.sup == "true") {
				el.innerHTML = `${value.slice(0, -2)}<sup>${value.slice(
					-2
				)}</sup>`;

				return;
			}

			el.textContent = value;
		});
};

export const addProductIdToCart = (
	product,
	success = () => null,
	error = () => null
) => {
};
